// extracted by css-extract-rspack-plugin
export default {"suppressOutline":"_40bcbc5a"};